import { FunctionalComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStreetView } from '@fortawesome/pro-regular-svg-icons/faStreetView';
import { StreetViewPanorama } from '@react-google-maps/api';
import { Location } from '@bringg/types';
import { useCallback, useMemo, useState } from 'preact/hooks';
import { faMap } from '@fortawesome/pro-regular-svg-icons/faMap';
import classNames from 'classnames';

interface Props {
	position: Location;
}

const defaultStreetViewOptions = {
	pov: { heading: 165, pitch: 0 },
	zoom: 1,
	linksControl: false,
	panControl: false,
	enableCloseButton: false,
	zoomControl: false,
	fullscreenControl: false,
	addressControl: false
};

const MapStreetView: FunctionalComponent<Props> = ({ position }) => {
	const [visible, setVisible] = useState<boolean>(false);

	const toggleStreetView = useCallback(() => setVisible(visible => !visible), []);

	const streetViewOption = useMemo(
		() => ({
			...defaultStreetViewOptions,
			visible,
			position
		}),
		[position, visible]
	);

	return (
		<div className={classNames('map-street-view', { 'close-street-view-icon': visible })}>
			{!visible && (
				<div onClick={toggleStreetView} className="map-street-view-icon">
					<FontAwesomeIcon className="icon" icon={faStreetView} />
				</div>
			)}
			{visible && (
				<div onClick={toggleStreetView} className="map-street-view-icon">
					<FontAwesomeIcon className="icon" icon={faMap} />
				</div>
			)}
			{visible && <StreetViewPanorama options={streetViewOption} />}
		</div>
	);
};

export default MapStreetView;
